import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { COSIGN_X_PLATFORM_TOKEN } from '@constants'
import { getXPlatformTokenWithCode } from '@cosign/utils/cookie'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import Cookies from 'js-cookie'

export function useMember() {
  const { campaignCodeFromUrl } = useCampaignCode()
  const hasToken = !!getXPlatformTokenWithCode(campaignCodeFromUrl)
  const { destructuredData: member } = useApiCampaignMember({ code: campaignCodeFromUrl }, {
    onError: () => {
      Cookies.remove(`${campaignCodeFromUrl}_${COSIGN_X_PLATFORM_TOKEN}`)
    },
  })

  return {
    member,
    hasToken,
  }
}
